export default __webpack_public_path__ + "static/media/product__blue_icon.56520c62.svg";